import {
    ADD_INSTRUCTOR_PRODUCT,
    DELETE_INSTRUCTOR_PRODUCT,
    UPDATE_INSTRUCTOR_PRODUCT,
    SET_INSTRUCTOR_PRODUCTS
} from 'store/reducers/instructorReducer'
import { snapshotToObjects } from 'util/firestore';
import {buildHeaders} from 'util/api/CheckoutAPI'
const BASE_URL = process.env.REACT_APP_APP_BASE_URL;

export const loadProducts = () => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        const partnerId = getState().instructor.instructor.platformID
        const db = getFirestore()
        return db.collection("classes").where("partnerId", "==", partnerId).where("location_type", "in", ["product", "ondemand"]).where("deleted", "==", false).get()
            .then(snapshot => {
                const products = snapshotToObjects(snapshot)
                console.log("Got products?")
                console.log(products.length)
                dispatch({type: SET_INSTRUCTOR_PRODUCTS, products: products})
                return products
            })
    }
}

export const deleteProduct = (product) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        const db = getFirestore()

        product = {
            ...product,
            deleted: true
        }

        return db.collection("classes").doc(product.id)
            .set({
                deleted: true
            }, {merge: true})
            .then(res => {
                dispatch({type: DELETE_INSTRUCTOR_PRODUCT, product: product})
                return res
            })
    }
}

export const saveProduct = (product) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {

        const state = getState()

        const partnerId = state.instructor.instructor.platformID

        product = {
            ...product,
            partnerId: state.instructor.instructor.platformID,
            instructor_id: state.instructor.instructor.platformID,
            host_ids: [
                state.instructor.instructor.platformID
            ],
            host_name: state.instructor.instructor.firstName,
            deleted: false
        }

        // product.partnerId = state.instructor.instructor.platformID
        // product.deleted = false

        const db = getFirestore()

        if (product.id) { // update
            return buildHeaders()
                .then(headers => {
                    return fetch(`${BASE_URL}/app/product?productId=${product.id}`, {
                        method: 'PUT',
                        headers: headers,
                        body: JSON.stringify({
                            product: product
                        })
                    })
                })
                .then(response => {
                    return response.json()
                })
                .then(json => {
                    console.log("Dispatching update product: ", json)
                    // dispatch({type: UPDATE_INSTRUCTOR_PRODUCT, product: product})
                    if (json.product) {
                        dispatch({type: UPDATE_INSTRUCTOR_PRODUCT, product: json.product})
                    }
                    return json
                })

        } else { // add new
            
            return buildHeaders()
                .then(headers => {
                    return fetch(`${BASE_URL}/app/product`, {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify({
                            product: product
                        })
                    })
                })
                .then(response => {
                    return response.json()
                })
                .then(json => {
                    console.log("product response")
                    // console.log(response)
                    console.log(json)
                    if (json.product) {
                        dispatch({type: ADD_INSTRUCTOR_PRODUCT, product: json.product})
                    }
                    return json
                })
        }
    }
}